import Message from 'shared_components/message';
import { axiosPhase2API, axiosLabAPI } from 'services/axios';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchAnalyzerItems() {
	let AnalyzerItems = [];

	try {
		const content = {
			method: API_GET_METHOD,
			url: `settings/labanalyzer`,
		}

		const response = await axiosLabAPI(content);
		const { data } = response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			AnalyzerItems = data.RECORDS;
		}
	} catch (e) {
		showMessage(e);
	}

	return AnalyzerItems;
}

export async function createAnalyzerItems(payload) {
	let createdAnalyzer;

	try {
		const content = {
			method: API_POST_METHOD,
			url: `settings/labanalyzer`,
			data: {
				p_analyzer_name: payload.analyzerName,
				p_is_active: payload.is_active,
			}
		}

		const response = await axiosLabAPI(content);
		const { data } = response;

		createdAnalyzer = data;
	} catch (e) {
		showMessage(e);
	}

	return createdAnalyzer;
}

export async function updateAnalyzerItems(payload) {
	let updatedAnalyzer;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: `settings/labanalyzer`,
			data: {
				p_analyzer_id: payload.analyzerID,
				p_analyzer_name: payload.analyzerName,
				p_is_active: payload.is_active,
			}
		}

		const response = await axiosLabAPI(content);
		const { data } = response;

		updatedAnalyzer = data;
	} catch (e) {
		showMessage(e);
	}

	return updatedAnalyzer;
}

export async function applySorting(payload) {
	let sortResponse;
	const url = `settings/labanalyzersorting`;

	try {
		const content = {
			method: API_PUT_METHOD,
			url,
			data: {
				p_analyzer_sorting_array: JSON.stringify(payload)
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		sortResponse = data;

		// Show success message from API response
		if (data && data.STATUSCODE === 200 && data.MESSAGE) {
			Message.success({ message: data.MESSAGE });
		}
	} catch (error) {
		showMessage(error);
	}

	return sortResponse;
}